import Axios from 'axios';
import { action, observable } from 'mobx';
import { ScrollPageInfo } from '@/models/data';
import { API } from '@/config/api';

export interface TakeoverItem {
  coin: string;
  createdTime: string;
  id: string;
  nominalValue: string;
  positionSide: PositionSide;
  positionSize: string;
  symbol: string;
}

export default class Takeover {
  @observable isFetchingTakeoverRecord: boolean;

  @observable takeoverRecord: TakeoverItem[];

  @observable takeoverRecordPageInfo: ScrollPageInfo;

  constructor() {
    this.takeoverRecord = [];
    this.takeoverRecordPageInfo = {
      hasPrev: false,
      hasNext: false,
    };

    this.isFetchingTakeoverRecord = false;
  }

  @action.bound
  setLoadingState(key: string, data: boolean) {
    // @ts-ignore
    this[key] = data;
  }

  //
  // 强平记录
  //

  @action
  setTakeoverRecord(data: TakeoverItem[]) {
    this.takeoverRecord = data;
  }

  @action.bound
  setTakeoverRecordPageInfo(data: ScrollPageInfo) {
    const origin = { ...this.takeoverRecordPageInfo };
    this.takeoverRecordPageInfo = { ...origin, ...data };
  }

  @action.bound
  async fetchTakeoverRecord({
    symbol,
    direction,
    limit = 20,
    id,
    startTime,
    endTime,
  }: {
    symbol?: string;
    direction: ScrollPaginationDirection;
    limit?: number;
    id?: string;
    startTime?: number;
    endTime?: number;
  }) {
    this.setLoadingState('isFetchingTakeoverRecord', true);

    const result: any = await Axios.get(API.TAKEOVER_LIST, {
      params: {
        symbol,
        direction,
        limit,
        id,
        startTime,
        endTime,
      },
    });

    if (result) {
      const { hasPrev, hasNext, items } = result;

      this.setTakeoverRecord(items || []);
      this.setTakeoverRecordPageInfo({ hasPrev, hasNext });
    }

    this.setLoadingState('isFetchingTakeoverRecord', false);
  }
}
